import { render, staticRenderFns } from "./PhysicianEntry.vue?vue&type=template&id=d82c485c&scoped=true&"
import script from "./PhysicianEntry.vue?vue&type=script&lang=js&"
export * from "./PhysicianEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82c485c",
  null
  
)

export default component.exports